import { useTranslation } from 'react-i18next';
import { ReportingMode } from '@/containers/Reporting/ReportingMode';
import { PendingDocuments } from './components/PendingDocuments';
import { SubmittedDocuments } from './components/SubmittedDocuments';
import s from './index.module.scss';

const ReportingPage = () => {
  const { t } = useTranslation('reporting');
  return (
    <div className={s.wrapper}>
      <div className="container-inner">
        <div className={s.content}>
          <div className={s.header}>
            <h1 className={s.title}>{t('reporting_page.title')}</h1>
            <p className={s.desc}>{t('reporting_page.description')}</p>
          </div>
          <ReportingMode />
          <PendingDocuments />
          <SubmittedDocuments />
        </div>
      </div>
    </div>
  );
};

export default ReportingPage;
